import React, { Component } from 'react';
import { ButtonGroup, Chip, CssBaseline, Grid, Typography, withStyles } from '@material-ui/core';
import axios from 'axios';
import './Program.css';
import axiosInstance, {
  CHANNEL,
  CHANNEL_DP,
  COMMON_IMG,
  EVENT_CODE,
  EVENT_DAYS,
  EVENT_ID,
  EVENT_NAME,
  EVENTS_API_URL,
  getEventDays,
  getEventId,
  WEB_API,
  EVENT_IMG,
  PROGRAM_API_URL,
} from '../constatns';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import Button from '@material-ui/core/Button';
import ProgramDetailDialog from './ProgramDetailDialog';
import { FaArrowsAltH } from 'react-icons/fa';

const moment = require('moment');
const styles = (theme) => ({
  table: {
    marginTop: '10px',
    overflowX: 'hidden',
    border: '1px solid #efefef',
  },
  dateButton: {
    textTransform: 'none',
  },
  chip: {
    background: '#930E11',
    color: '#fff',
    marginLeft: '5px',
    fontSize: '15px',
    height: '24px',
  },
});
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.primary.bg,
    color: theme.palette.primary.point,
    fontWeight: 'bold !important',
    [theme.breakpoints.down('sm')]: {
      fontSize: 10,
    },
    '&:not(:first-child)': {
      borderLeft: '1px solid ',
      borderBottom: '0px',
      borderColor: 'white',
    },
  },
  body: {
    fontSize: 13,
    [theme.breakpoints.down('sm')]: {
      fontSize: 10,
    },
    '&:not(:first-child)': {
      borderLeft: '1px solid ',
      borderColor: theme.palette.primary.bg,
      // width: '21%',
      // padding: '24px 16px',
      padding: 'auto 8px',
      // width: '19%',
      width: '16%',
      //**custom height 고정값
      height: '145px',
    },
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '& td': {
      // width: '48%',
    },
    '& th:first-child': {
      width: '5%',
      // verticalAlign: 'top',
      padding: '0px 8px',
      fontSize: '1em',
    },
    '&:nth-of-type(odd)': {
      // backgroundColor: theme.palette.action.hover,

      border: '1px solid #efefef',
    },

    '&:nth-of-type(even)': {
      // backgroundColor: theme.palette.action.hover,

      border: '1px solid #efefef',
    },
    '&.isBreak': {
      // backgroundColor: theme.palette.action.hover,
      backgroundColor: '#bfbfbf',

      '& th, td': {
        //**custom height 고정값
        height: 50,
        // paddingTop: '8px',
        // paddingBottom: '8px',
        fontWeight: 700,
      },
      '& th:first-child': {
        //verticalAlign: 'top',
        padding: '0px 8px',
        // fontSize: '0.8em',
        fontWeight: 300,
        fontSize: '1em',
      },
    },
    '&.isLive': {
      backgroundColor: theme.palette.error,
    },
  },
}))(TableRow);

class Program extends Component {
  //static contextType = MainContext;
  constructor(props) {
    super(props);
    this.state = {
      arrDate: [],
      rows: [],
      selectDate: moment().format('YYYYMMDD'),
      programDetailDialog: false,
      pgmVodDialog: false,
      detail: [],
    };
  }

  componentDidMount() {
    // const eventDays = getEventDays();
    // this.setState({ arrDate: eventDays._buffs }, () => {
    //   this.getNumber(0);
    //   // console.log(getEventDays());
    // });

    let item = JSON.parse(sessionStorage.getItem('EVENT'));
    if (!item) {
      axiosInstance
        .get(`${WEB_API}/event/info?eventId=${getEventId()}&code=${encodeURIComponent(EVENT_CODE)}`, {
          headers: { Pragma: 'no-cache' },
        })
        .then((response) => {
          if (response.data.Item) {
            sessionStorage.setItem('EVENT_ID', getEventId());
            sessionStorage.setItem('EVENT', JSON.stringify(response.data.Item));
            const eventDays = getEventDays();
            this.setState({ arrDate: eventDays._buffs });
            this.getNumber(0);
          }
        });
    } else {
      const eventDays = getEventDays();
      this.setState({ arrDate: eventDays._buffs }, () => {
        this.getNumber(0);
        // console.log(getEventDays());
      });
      // this.getNumber(0);
    }
  }

  getNumber(idx) {
    let _date = new Date();
    let item = JSON.parse(sessionStorage.getItem('EVENT'));

    if (item) {
      if (this.state.arrDate) _date = moment(this.state.arrDate[idx]).format('YYYYMMDD');
      else _date = moment(item.startDate).format('YYYYMMDD');
    } else {
      _date = moment('20221111').format('YYYYMMDD');
    }
    this.setState({ selectDate: _date, pgmBriefIdx: idx }, () => {
      // console.log(this.state.selectDate, 'selectDate');
    });

    axios
      .get(`${EVENTS_API_URL}/event/pgmByDate?eventId=${EVENT_ID}&date=${_date}`, { headers: { Pragma: 'no-cache' } })
      .then((response) => {
        let data = response.data.Items;
        data = data.sort((a, b) => {
          return a.startTime > b.startTime ? 1 : -1;
        });
        // console.log(data, 'data');
        const mapItem = new Map();
        data.map((data) => {
          if (mapItem.has(data.startTime)) {
            mapItem.get(data.startTime)[data.channel] = data.pgTitle;
            mapItem.get(data.startTime)[data.channel + '_sub'] = data.pgSub;
            mapItem.get(data.startTime)[data.channel + '_logo'] = data.pgSub.includes('/images/');
            mapItem.get(data.startTime)[data.channel + '_isEng'] = data.isEng;
            mapItem.get(data.startTime)[data.channel + '_id'] = data.id;
            mapItem.get(data.startTime)[data.channel + '_pgStyle'] = data.pgStyle;
            if (data.vod && data.vod.length > 2) {
              mapItem.get(data.startTime)[data.channel + '_vod'] = data.vod;
            }

            // let buff = false;
            mapItem.get(data.startTime)[data.channel + '_isLive'] = false;
          } else {
            // let buff = false;
            mapItem.set(data.startTime, {
              time: data.startTime,
              [data.channel]: data.pgTitle,
              [data.channel + '_sub']: data.pgSub,
              [data.channel + '_logo']: data.pgSub.includes('/images/'),
              isBreak: data.isBreak,
              [data.channel + '_isEng']: data.isEng,
              [data.channel + '_id']: data.id,
              [data.channel + '_pgStyle']: data.pgStyle,
              [data.channel + '_vod']: data.vod,
              [data.channel + '_isLive']: false,
              endTime: data.endTime,
            });
          }
        });

        // if (Array.from(mapItem)[1][1].Room1_id === 'evt029_pg077') {
        //   Array.from(mapItem)[1][1].isBreak = false;
        // }
        // if (Array.from(mapItem)[3][1].Room1_id === 'evt029_pg145') {
        //   Array.from(mapItem)[3][1].isBreak = false;
        // }

        // console.log(Array.from(mapItem));
        this.setState({ rows: Array.from(mapItem) });
      });
  }

  showDetail = (cn, row, sub) => {
    if (!row[1].isBreak) {
      const pgmId = row[1][`${cn}_id`];
      const pgTitle = row[1][`${cn}`];
      const pgSub = sub;
      const ch = `${cn}`;
      const selData = {
        pgTitle: pgTitle,
        pgSub: pgSub,
        ch: ch,
        pgmId: pgmId,
        dpTime: `${row[0]} - ${row[1].endTime}`,
      };
      // axios.get(`${WEB_API}/program/detail?eventId=${EVENT_ID}&pgmId=${pgmId}`, { headers: { Pragma: 'no-cache' } }).then((response) => {
      axios
        .get(`${PROGRAM_API_URL}/program/detail?eventId=${EVENT_ID}&pgmId=${pgmId}`, { headers: { Pragma: 'no-cache' } })
        .then((response) => {
          // console.log(response, 'response');
          response.data.sort(function (a, b) {
            const ao = a.order ? Number(a.order) : 0;
            const bo = b.order ? Number(b.order) : 0;
            return ao < bo ? -1 : 0;
          });
          this.setState({ selData: selData, detail: response.data, programDetailDialog: true });
        });
    }
  };

  clickProgram = (e, ch) => {
    e.stopPropagation();
    let win = window.open(`/#/live?ch=${ch}`, 'liveWin');
    win.document.title = EVENT_NAME + ' - Live';

    if (window.name === 'liveWin') {
      win.location.reload();
    }
  };

  clickVOD = (e, vod) => {
    const testVideo = 'https://s3.ap-northeast-2.amazonaws.com/hemlibra.web-symposium.co.kr/static/media/test1.8ab528fa.mp4';
    e.stopPropagation();
    if (!vod || vod === undefined || vod === '') {
      this.setState({ vodId: testVideo, pgmVodDialog: true });
    } else {
      this.setState({ vodId: vod, pgmVodDialog: true });
    }
  };

  getCell = () => {
    // const { classes } = this.props;
    // console.log(this.state.rows, 'rows');

    return this.state.rows.map((row) => {
      // console.log(row);
      return (
        <StyledTableRow key={row[1].time} className={row[1].isBreak ? 'isBreak' : ''}>
          <StyledTableCell
            align="center"
            component="th"
            scope="row"
            style={{ backgroundColor: '#fff' }}
            // style={
            //   (this.state.pgmBriefIdx === 1 && row[1].time === '08:30') || (this.state.pgmBriefIdx === 2 && row[1].time === '09:40')
            //     ? { backgroundColor: '' }
            //     : {}
            // }
          >
            {row[1].Room1_id !== 'evt029_pg189' && row[1].Room1_id !== 'evt029_pg193' && `${row[1].time} ~`}

            {row[1].endTime}
            {/* {this.state.pgmBriefIdx === 1 && row[1].time === '08:30'
              ? '08:40'
              : this.state.pgmBriefIdx === 2 && row[1].time === '09:40'
              ? '09:50'
              : row[1].time !== '18:20' && row[1].endTime} */}
          </StyledTableCell>
          {CHANNEL.map((ch, idx) => {
            let isDP = true;
            if (row[1][ch + '_id'] !== 'pgm_1657789919849') isDP = true;
            if (row[1].isBreak && idx !== 0) isDP = false;
            if (isDP) {
              return (
                <StyledTableCell
                  colSpan={
                    // this.props.width !== 'xs' && this.props.width !== 'sm' && idx === 0 && row[1].isBreak
                    //   ? CHANNEL.length
                    //   : row[1][ch + '_id'] === 'evt120_pg016'
                    //   ? 1
                    row[1][ch + '_id'] === 'evt120_pg061' || row[1][ch + '_id'] === 'evt120_pg081'
                      ? 5
                      : row[1][ch + '_id'] === 'pgm_1663826545610'
                      ? 1
                      : row[1][ch + '_id'] === 'evt120_pg016' ||
                        row[1][ch + '_id'] === 'evt120_pg026' ||
                        row[1][ch + '_id'] === 'evt120_pg066' ||
                        row[1][ch + '_id'] === 'evt120_pg077' ||
                        row[1][ch + '_id'] === 'evt120_pg115'
                      ? 2
                      : row[1][ch + '_id'] === 'pgm_1657790226825' ||
                        row[1][ch + '_id'] === 'evt120_pg021' ||
                        row[1][ch + '_id'] === 'evt120_pg119'
                      ? 3
                      : this.props.width !== 'xs' &&
                        this.props.width !== 'sm' &&
                        // idx === 0 &&
                        row[1].isBreak &&
                        row[1][ch + '_id'] !== 'pgm_1658194371370'
                      ? CHANNEL.length
                      : 0
                  }
                  rowSpan={
                    !row[1].isBreak && row[1].Room1_id === 'evt029_pg077' && ch === 'Room1'
                      ? 3
                      : row[1][ch + '_id'] === 'pgm_1667180884317'
                      ? // row[1].Room1_id === 'evt029_pg145'//|| (row[1].Room1_id === 'evt029_pg137' && ch === 'Room1')
                        2
                      : 1
                  }
                  key={idx}
                  align="center"
                  style={
                    row[1][ch + '_id'] === 'evt029_pg142' || row[1][ch + '_id'] === 'evt029_pg074'
                      ? {
                          cursor: 'pointer',
                          backgroundColor: 'rgb(242,242,242) !important',
                          paddingTop: '4px',
                          paddingBottom: '4px',
                        }
                      : row[1][ch + '_id'] === 'evt029_pg073' ||
                        row[1][ch + '_id'] === 'evt029_pg075' ||
                        row[1][ch + '_id'] === 'evt029_pg076' ||
                        row[1][ch + '_id'] === 'evt029_pg143' ||
                        row[1][ch + '_id'] === 'evt029_pg144' ||
                        !row[1][ch]
                      ? {
                          display: 'none',
                        }
                      : {
                          cursor: 'pointer',
                          backgroundColor:
                            row[1][ch + '_id'] === 'evt029_pg074'
                              ? 'rgb(242,242,242) !important'
                              : row[1][ch + '_pgStyle']
                              ? `${row[1][ch + '_pgStyle']}`
                              : '',
                        }
                  }
                  onClick={(e) => this.showDetail(ch, row)}
                >
                  {!row[1].isBreak && row[1][ch + '_isEng'] ? (
                    <Chip size="small" label="Eng" style={{ fontSize: '1em', backgroundColor: '#164578', color: '#fff' }} />
                  ) : (
                    !row[1].isBreak && null
                  )}
                  {row[1].isBreak && idx === 0 ? row[1][ch] : ''}
                  {!row[1].isBreak && (
                    <div>
                      <div
                        style={row[1][ch + '_id'] === 'evt029_pg074' || row[1][ch + '_id'] === 'evt029_pg142' ? {} : { fontWeight: 'bold' }}
                      >
                        {row[1][ch]}
                        {row[1][`${ch}_sub`] && row[1][`${ch}_sub`].indexOf('For Korean Only') !== -1 ? (
                          <Chip
                            size="small"
                            label="KOR"
                            style={{ backgroundColor: 'rgb(127, 0, 15)', color: 'white', fontSize: '1em', marginLeft: '5px' }}
                          />
                        ) : null}
                      </div>

                      {/* {(row[1][ch + '_id'] === 'evt029_pg039' || row[1][ch + '_id'] === 'evt029_pg156' || row[1][ch + '_id'] === 'evt029_pg164') ? ( */}
                      {/* DETERMINE if SUBTITLE IS A LOGO */}
                      {/* 
                      {row[1][`${ch}_id`] === 'evt120_pg060' ||
                        row[1][ch + '_id'] === 'evt120_pg070' ||
                        (row[1][ch + '_id'] === 'evt120_pg128' && (
                          <div style={{ width: '100%', textAlign: 'center' }}>
                            <img src={`${EVENT_IMG}/sponsor/dia_01.png`} style={{ width: '100px' }} alt="logo" />
                          </div>
                        ))} */}
                      {row[1][`${ch}_id`] === 'evt120_pg060' ||
                      row[1][ch + '_id'] === 'evt120_pg070' ||
                      row[1][ch + '_id'] === 'evt120_pg128' ? (
                        <div style={{ width: '100%', textAlign: 'center' }}>
                          <img src={`${EVENT_IMG}/sponsor/dia_01.png`} style={{ width: '100px' }} alt="logo" />
                        </div>
                      ) : row[1][ch + '_id'] === 'evt120_pg080' || row[1][ch + '_id'] === 'pgm_1658400077861' ? (
                        <div style={{ width: '100%', textAlign: 'center' }}>
                          <img src={`${EVENT_IMG}/sponsor/platinum_01.png`} style={{ width: '100px' }} alt="logo" />
                        </div>
                      ) : row[1][ch + '_id'] === 'evt120_pg153' ? (
                        <div style={{ width: '100%', textAlign: 'center' }}>
                          <img src={`${EVENT_IMG}/sponsor/mmi_logo.png`} style={{ width: '100px' }} alt="logo" />
                        </div>
                      ) : (
                        <div style={{ whiteSpace: 'pre-line' }}>
                          {row[1][ch] &&
                            (row[1][ch].indexOf('Gender Surgery') !== -1 ? (
                              <b>{row[1][ch + '_sub']}</b>
                            ) : row[1][ch + '_sub'].indexOf('For Korean Only') !== -1 ? null : row[1][ch].indexOf('Free Paper') !== -1 ? (
                              row[1][ch + '_sub']
                            ) : (
                              row[1][ch + '_sub'].replace('(', '\n(')
                            ))}
                        </div>
                      )}
                    </div>
                  )}
                  {!row[1].isBreak && row[1][ch + '_vod'] ? (
                    <Chip
                      size="small"
                      label="Replay"
                      style={{ backgroundColor: '#9ccc65', color: 'white', fontSize: '1em', marginLeft: '5px' }}
                      onClick={(e) => {
                        this.clickVOD(e, row[1][ch + '_vod']);
                      }}
                    />
                  ) : null}
                  {!row[1].isBreak && row[1][ch + '_isLive'] ? (
                    <img
                      src={`${COMMON_IMG}/live.gif`}
                      style={{
                        width: '50px',
                        height: 'auto',
                        verticalAlign: 'middle',
                        marginLeft: '5px',
                        // cursor: 'Pointer',
                      }}
                      onClick={(e) => {
                        this.clickProgram(e, ch);
                      }}
                      alt={'live-icon'}
                    />
                  ) : null}
                </StyledTableCell>
              );
            }
          })}
        </StyledTableRow>
      );
    });
  };

  getDateButton = () => {
    const eventDays = getEventDays();
    const selectIdx = eventDays._buffsValue.indexOf(this.state.selectDate);
    return EVENT_DAYS.map((data, idx) => {
      return (
        <Button
          key={idx}
          className={this.props.classes.dateButton}
          onClick={() => {
            this.getNumber(idx);
          }}
          variant={selectIdx === idx ? 'contained' : 'outlined'}
        >
          {moment(data).format('MMMM DD (ddd)')}
        </Button>
      );
    });
  };

  render() {
    const { classes } = this.props;
    // console.log(this.state.selectDate);

    return (
      <React.Fragment>
        <CssBaseline />
        <ButtonGroup color="primary" disableElevation aria-label="outlined primary button group" fullWidth>
          {this.getDateButton()}
        </ButtonGroup>
        {/*<Grid*/}
        {/*  container*/}
        {/*  style={{*/}
        {/*    backgroundColor: 'rgba(175,35,44,0.5)',*/}
        {/*    color: 'rgba(0, 0, 0, 0.87)',*/}
        {/*    padding: '10px 0',*/}
        {/*    borderRadius: 4,*/}
        {/*    marginTop: 10,*/}
        {/*    fontWeight: 'bold',*/}
        {/*  }}*/}
        {/*>*/}
        {/*  <Grid item xs={2} align="center">*/}
        {/*    {pgmBrief[this.state.pgmBriefIdx].day}*/}
        {/*  </Grid>*/}
        {/*  <Grid item xs={6} align="center">*/}
        {/*    {pgmBrief[this.state.pgmBriefIdx].title}*/}
        {/*  </Grid>*/}
        {/*  <Grid item xs={4} align="center">*/}
        {/*    {pgmBrief[this.state.pgmBriefIdx].announcer}*/}
        {/*  </Grid>*/}
        {/*</Grid>*/}
        <TableContainer>
          <Table className={classes.table} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell align="center" style={{ backgroundColor: '#237a9d', color: '#fff', fontSize: 16 }}>
                  Time(KST)
                </StyledTableCell>
                {CHANNEL_DP.map((c, idx) => {
                  return (
                    <>
                      {idx < 3 ? (
                        <StyledTableCell key={'ch-' + idx} align="center" style={{ backgroundColor: '#237a9d', color: '#fff', padding: 0 }}>
                          <Grid container>
                            <Grid container item xs={4} style={{ padding: 0 }}>
                              <Grid container justifyContent="center" alignItems="center" item xs={5}>
                                <Grid item xs={10} container justifyContent="center" alignItems="center">
                                  <img src={`${EVENT_IMG}/ic/ic_room_01.png`} alt="" style={{ width: '100%' }} />
                                </Grid>
                              </Grid>
                              <Grid container justifyContent="center" alignContent="center" item xs={2}>
                                <FaArrowsAltH />
                              </Grid>
                              <Grid container justifyContent="center" alignItems="center" item xs={5}>
                                <Grid item xs={10} container justifyContent="center" alignItems="center">
                                  <img src={`${EVENT_IMG}/ic/ic_room_02.png`} alt="" style={{ width: '100%' }} />
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid container justifyContent="center" item xs={4} style={{ fontSize: 16 }}>
                              {c}
                            </Grid>
                            <Grid item xs={4} />
                          </Grid>
                        </StyledTableCell>
                      ) : (
                        <StyledTableCell
                          key={'ch-icon' + idx}
                          align="center"
                          style={{ backgroundColor: '#237a9d', color: '#fff', fontSize: 16 }}
                        >
                          {c}
                        </StyledTableCell>
                      )}
                    </>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {this.state.rows.length > 0 ? (
                <>
                  {this.getCell()}
                  {this.state.selectDate === '20221111' && (
                    <StyledTableRow className="isBreak">
                      <StyledTableCell style={{ backgroundColor: '#fff', fontWeight: 300, fontSize: 14, textAlign: 'center' }}>
                        18:30 ~
                      </StyledTableCell>
                      <StyledTableCell style={{ backgroundColor: '#fff' }} />
                      <StyledTableCell style={{ backgroundColor: '#bfbfbf', fontWeight: 'bold', textAlign: 'center' }}>
                        Welcome Reception
                      </StyledTableCell>
                      <StyledTableCell colSpan={4} style={{ backgroundColor: '#fff' }}></StyledTableCell>
                    </StyledTableRow>
                  )}
                </>
              ) : null}
            </TableBody>
          </Table>
          <Grid container justifyContent="flex-end" style={{ marginTop: 10, color: 'red', fontWeight: 'bold' }}>
            <Grid container style={{ width: '220px' }}>
              <Grid container>
                <Typography style={{ fontWeight: 'bold' }}> * Subject to change</Typography>
              </Grid>
              <Grid container justifyContent="flex-start">
                <Typography style={{ fontWeight: 'bold' }}> * Translation</Typography>
                <Grid container alignItems="center" style={{ width: '100px', paddingLeft: '8px' }}>
                  <Grid item xs={5}>
                    <img src={`${EVENT_IMG}/ic/ic_room_01.png`} alt="" style={{ width: '100%' }} />
                  </Grid>
                  <Grid item xs={2}>
                    <FaArrowsAltH />
                  </Grid>
                  <Grid item xs={5}>
                    <img src={`${EVENT_IMG}/ic/ic_room_02.png`} alt="" style={{ width: '100%', border: '1px solid grey' }} />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </TableContainer>
        <ProgramDetailDialog
          selData={this.state.selData}
          data={this.state.detail}
          open={this.state.programDetailDialog}
          onClose={() => this.setState({ programDetailDialog: false })}
          disableBackdrop={false}
        />
        {/*<PgmVodDialog*/}
        {/*  open={this.state.pgmVodDialog}*/}
        {/*  onClose={() => this.setState({ pgmVodDialog: false })}*/}
        {/*  disableBackdrop={false}*/}
        {/*  vodId={this.state.vodId}*/}
        {/*/>*/}
      </React.Fragment>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Program);
